export function formatCalendarDate(date: Date) {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");

	return `${year}-${month}-${day}`;
}

export function parseCalendarDate(value: string) {
	const calendarDate = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
	if (!calendarDate) return new Date(value);

	return new Date(
		Number(calendarDate[1]),
		Number(calendarDate[2]) - 1,
		Number(calendarDate[3])
	);
}

export function calendarDateToIsoTimestamp(value?: string) {
	if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
	return parseCalendarDate(value).toISOString();
}
